import React, { useEffect, useRef } from 'react';

export default function PayPalButton({ buttonId, renderDelay = 0 }) {
  const containerRef = useRef(null);
  const buttonRendered = useRef(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.paypal && containerRef.current && !buttonRendered.current) {
        try {
          // Clear previous content
          containerRef.current.innerHTML = '';
          
          // Render PayPal hosted button
          window.paypal.HostedButtons({
            hostedButtonId: buttonId,
          }).render(containerRef.current);
          
          buttonRendered.current = true;
        } catch (error) {
          console.error('PayPal button render error:', error);
        }
      }
    }, renderDelay);

    // Cleanup function
    return () => {
      clearTimeout(timer);
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
      buttonRendered.current = false;
    };
  }, [buttonId, renderDelay]);

  return (
    <div 
      ref={containerRef}
      className="w-full paypal-button-container"
      style={{ minHeight: '45px' }}
    />
  );
}
